import router from "@/router/index";
import API from "@/api";
const User = API.get("User");

export default {
  namespaced: true,

  state: {
    data: JSON.parse(localStorage.getItem("user")),
    token: localStorage.getItem("auth_token"),
  },

  getters: {
    profile: (state) => state.data,
    type: (state) => state.data?.user_type,
    token: (state) => state.token,
    status: (state) => {
      var data = state.data;
      var status = "";

      if (data.user_type === "doctor") {
        if (data.doctor) {
          status = data.doctor.status;
        }
      }

      return status;
    },
    fullName: (state) => {
      var data = state.data;
      if (!data) return "N⁄A";

      var profile = null;
      if (data.user_type === "doctor") profile = data.doctor;
      else if (data.user_type === "tma")  profile = data.tma;

      var name = "";
      if (profile !== null) {
        if (Object.prototype.hasOwnProperty.call(profile, "fullname")) {
          if (profile.fullname && profile.fullname !== null) {
            name = profile.fullname;
          } else {
            if (profile.first_name || profile.last_name) {
              name = `${profile.first_name} ${profile.last_name}`;
            } else {
              name = data.email;
            }
          }
        } else {
          name = data.email;
        }
      } else {
        name = data.email;
      }
      return name;
    },
  },

  mutations: {
    setUser(state, user) {
      state.data = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    removeUser(state) {
      localStorage.removeItem("user");
      state.data = null;
      // deprecation test
      // state.data = {
      //   id: null,
      //   first_name: null,
      //   middle_name: null,
      //   last_name: null,
      //   nickname: null,
      //   profile_image: null,
      //   mobile_number: null,
      //   phone_number: null,
      //   email: null,
      //   address: null,
      //   user_id: null,
      //   created_at: null,
      //   updated_at: null,
      //   deleted_at: null
      // }
    },
    setToken(state, token) {
      localStorage.setItem("auth_token", token);
      state.token = token;
    },
    removeToken(state) {
      localStorage.removeItem("auth_token");
      state.token = null;
    },
  },

  actions: {
    async signIn(context, { user, token }) {
      context.commit("setUser", user);
      context.commit("setToken", token);
      router.push({ name: "Dashboard" });
    },
    async signOut(context) {
      await context.dispatch("updateStatus", "Offline");
      await context.commit("removeUser");
      await context.commit("removeToken");
      router.push({ name: "Login" });
    },

    /**
     * Updates doctor's status
     * - In call
     * - Available/Online?
     * - After call work
     * - Away
     * - Do not disturb
     * - End of shift
     * @param {String} status
     */
    async updateStatus({ getters }, status = "") {
      if (getters.type === "doctor") {
        const id = getters.profile.id;
        const payload = {
          status: status,
          is_doctor: 1,
        };
        let response = await User.updateUser(id, payload);
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      // if (getters.type === "tma") {
      //   const id = getters.profile.id;
      //   const payload = {
      //     status: status,
      //     is_tma: 1,
      //   };
      //   let response = await User.updateUser(id, payload);
      //   localStorage.setItem("user", JSON.stringify(response.data));
      // }
    },
  },
};
